export const css = {
	tgHeader: 'P1jN0W3V',
	tailRoot: '_7pMscC9Z',
	tgDetails: 'E750XYbA',
	card: 'uGwxXS2L',
	leading: 'hpj-Cxiy',
	trailing: 'kDZ2zXWb',
	basefont: '_9rrdHtXE',
	titlefont: 'gGfXxQRD',
	alphaHalfBlack: '_5aS-UQ2P',
	actions: 'G132xShm',
	' _key': 'mc-widgets/where-you-left-off'
};

export default css;
